import { STATUS_COLORS } from "../app/common/constants/status-colors";

export function getStatusColor(status: string): 'green' | 'red' | 'yellow' | 'gray' {
  return STATUS_COLORS[status] || 'gray';
}
